import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Select} from 'antd'

@inject('store') @observer
class StockFilterSelect extends Component {
  componentDidMount() {
    this.props.store.stockFilter.list.load()
  }
  changeHandler = (value) => {
    this.props.store.algo.single.selectStockFilter(value)
  }
  removeError = () => {
    this.props.store.algo.single.removeError('stock_filter')
  }
  render() {
    const {stockFilter, algo} = this.props.store
    const {errors} = algo.single
    const errorHighlighting = errors.stock_filter ? {background: 'rgba(255,0,0,0.3)'} : {}
    return(
      <div style={{width: '100%'}}>
        <Select
          id='stock_filter_id'
          name='stock_filter'
          value={algo.single.data.stock_filter?.id}
          onChange={this.changeHandler}
          onFocus={this.removeError}
          style={errorHighlighting}
          size='large'
        >
          <Select.Option value=''>---------</Select.Option>
          {stockFilter.list.data.map((filter) =>
            <Select.Option
              value={filter.id}
              key={filter.id}
            >
              {`${filter.name} (${filter.selected_tickers.tickers.length || 'no'}
              ${filter.selected_tickers.tickers.length === 1 ? 'ticker' : 'tickers'})`}
            </Select.Option>
          )}
        </Select>
        {errors.stock_filter ?
          <p style={{fontSize: '12px', color: '#f6504d'}}>
            Please select a stock filter.
          </p>
          :
          null
        }
      </div>
    )
  }
}

export default StockFilterSelect
